import * as React from "react";
import { TableColumn } from "../../types";
import { InternalLink } from "../../components/InternalLink";
import { Links } from "../../../../schema/types/base";
import { linksOf } from "../../../../services/cpln";
import { useAppSelector } from "../../../../store/hooks";
import { selectGvc, selectOrg } from "../../../../store/contextSlice";
import { gvcScopedKinds } from "../../../../services/utils";

const nameDescriptionDefault = { id: "name", label: "Name" };
export function NameDescriptionColumn<TData extends { name: string; description: string; kind: string; links?: Links }>(
  column: Partial<TableColumn<TData>> = nameDescriptionDefault,
  options?: {
    shouldSkipLink?: (item: TData) => boolean;
    shouldForceTargetBlank?: (item: TData) => boolean;
    linkProperty?: string;
  },
) {
  const preset: TableColumn<TData> = {
    ...nameDescriptionDefault,
    enableResize: true,
    enableSort: true,
    size: 200,
    cell: (p) => {
      const org = useAppSelector(selectOrg);
      const gvc = useAppSelector(selectGvc);

      const item = p.row.original;
      const linkProperty = options?.linkProperty || "name";
      let link = `/console/org/${org}${gvcScopedKinds.includes(item.kind) ? `/gvc/${gvc}` : ""}/${item.kind}/${
        item[linkProperty]
      }`;

      if (gvcScopedKinds.includes(item.kind)) {
        const itemGvcLink = linksOf(item).gvc!;
        link = `/console${itemGvcLink}/${item.kind}/${item[linkProperty]}`;
      }

      const isSame = item.name === item.description;

      let skipLink = false;
      if (options && options.shouldSkipLink) {
        skipLink = options.shouldSkipLink(item);
      }
      let shouldForceTargetBlank = false;
      if (options && options.shouldForceTargetBlank) {
        shouldForceTargetBlank = options.shouldForceTargetBlank(item);
      }

      return React.useMemo(
        () => (
          <div className="flex flex-col justify-center" style={{ height: 56 }}>
            {skipLink ? (
              <span>{item.name}</span>
            ) : (
              <InternalLink label={item.name} to={link} forceTargetBlank={shouldForceTargetBlank} />
            )}
            {isSame ? null : <span className="text-sm description">{item.description}</span>}
          </div>
        ),
        [item.name, item.description],
      );
    },
  };
  return Object.assign(preset, column);
}
